export default __webpack_public_path__ + "static/biology-04c1e78e5cb2763933a49a76051fb37b.png";